/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { language, STYLES } from "config";
import { makeStyles } from "@material-ui/core/styles";
import UsersCombo from "../../components/UsersCombo";
import moment from "moment";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import AlertDialog from "../../components/AlertDialog";
import CustomDropDownPicker from "components/CustomDropDownPicker";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  FormText,
  Container
} from "reactstrap";
import FlatList from "flatlist-react";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1)
    }
  },
  "@global": {
    body: {
      backgroundColor: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }
  },
  pageContainer: {
    padding: "20px 0",
    backgroundColor: "#f8f9fa"
  },
  card: {
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    border: "none",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 24px rgba(0,0,0,0.12)"
    }
  },
  cardHeader: {
    background: `linear-gradient(135deg, ${STYLES.PRIMARY_APP_CLR} 0%, ${STYLES.SECONDARY_APP_CLR} 100%)`,
    color: "white",
    borderRadius: "12px 12px 0 0 !important",
    padding: "16px 24px",
    borderBottom: "none"
  },
  cardTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    margin: "0"
  },
  detailLabel: {
    fontSize: "0.85rem",
    fontWeight: "600",
    color: "#6c757d",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "4px"
  },
  detailValue: {
    fontSize: "1rem",
    fontWeight: "400",
    color: "#212529",
    marginBottom: "16px",
    wordBreak: "break-word"
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: STYLES.PRIMARY_APP_CLR,
    marginBottom: "24px",
    paddingBottom: "8px",
    borderBottom: `2px solid ${STYLES.TERTIARY_APP_CLR}`
  },
  button: {
    borderRadius: "8px",
    fontWeight: "600",
    padding: "10px 20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    }
  },
  primaryButton: {
    backgroundColor: STYLES.PRIMARY_BUTTON_CLR,
    border: "none",
    "&:hover": {
      backgroundColor: "#0056b3"
    }
  },
  secondaryButton: {
    backgroundColor: STYLES.TERTIARY_APP_CLR,
    border: "none",
    "&:hover": {
      backgroundColor: "#5a6268"
    }
  },
  dangerButton: {
    backgroundColor: "#dc3545",
    border: "none",
    "&:hover": {
      backgroundColor: "#c82333"
    }
  },
  backButton: {
    marginBottom: "24px",
    backgroundColor: "#6c757d",
    border: "none",
    "&:hover": {
      backgroundColor: "#5a6268"
    }
  },
  modalHeader: {
    background: `linear-gradient(135deg, ${STYLES.PRIMARY_APP_CLR} 0%, ${STYLES.SECONDARY_APP_CLR} 100%)`,
    color: "white",
    borderBottom: "none",
    borderRadius: "12px 12px 0 0"
  },
  gridContainer: {
    marginBottom: "16px"
  },
  formControl: {
    marginBottom: "16px"
  }
}));

const StaffEnquiryInformation = (props) => {
  ////////////////////REduX////////////////////
  const { api } = useContext(FirebaseContext);
  const { GetDateString, updateBooking, fetchChatMessages, clearLoginError, UpdateEnquiry, fetchCurrentAdminsBranchEnquiries } =
    api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const regions = useSelector((state) => state.regionData.regions);
  const brokers = useSelector((state) => state.brokers.users);
  // const Booking?.Medical_Information? = useSelector(
  //   (state) => state.medicalRecords.medicalHistoryRecords
  // );
  const navigate = useNavigate();
  const location = useLocation();
  ////////////////////constant////////////////////
  const Booking = (props.location && props.location.state.Booking) || {};
  const [updatebooking, setupdatebooking] = useState(Booking);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const usersdata = useSelector((state) => state.brokers);
  const [Brokers, setBrokers] = useState([]);
  const [brokerList, setBrokerList] = useState([]);

  const [Landlords, setLandlords] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rejectbuttonclicked, setrejectbuttonclicked] = useState(false);
  const [acceptbuttonclicked, setacceptbuttonclicked] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [commonAlert, setCommonAlert] = useState({
    open: false,
    msg: "",
    title: ""
  });
  const [details, setdetails] = useState([]);
  const pullforwardReasons = [
    { label: "Not Looking", value: "Not Looking" },
    { label: "Renew Lease", value: "Renew Lease" },
    { label: "Other", value: "Other" }
  ]

  const pullforwardTypes = [
    { label: "For All", value: "For All" },
    { label: "For a Broker", value: "For a Broker" }
  ]

  const [editPullForwardData, setEditPullForwardData] = useState({})

  useEffect(() => {
    populateEditPullForwardData();
  }, [details])

  useEffect(() => {
    console.log(`edit pull forward data: ${JSON.stringify(editPullForwardData)}`);
  }, [editPullForwardData])

  useEffect(() => {
    setdetails(location.state.item);
    console.log("details", location.state.item);
  }, []);

  //////////////functions needed for code to run//////////////
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    if (updatebooking.status === "ACCEPTED") {
      props.history.push("/bookingrequest");
    }
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const populateEditPullForwardData = () => {
    setEditPullForwardData({
      pullforward: details?.pullforward?.pullforward || "",
      pullforwardDate: details?.pullforward?.pullforwardDate || null,
      pullforwardNote: details?.pullforward?.pullforwardNote || "",
      pullforwardType: details?.pullforward?.pullforwardType || "",
      shareBrokers: details?.pullforward?.shareBrokers || []
    })
  }

  const convertUnix = (timestamp) => {
    const date = new Date(timestamp);

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as yyyy/mm/dd
    const formattedDate = `${year}/${month}/${day}`;
    return formattedDate;
  }

  const convertUnixDash = (timestamp) => {
    const date = new Date(timestamp);

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as yyyy-mm-dd
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  useEffect(() => {
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
          arr.push({
            value: element.id, // The broker ID (or name if preferred)
            label: `${element.firstName} ${element.lastName}`, // Broker name
          });
        }
      }
      setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    }
  }, [brokers]);

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    pullForward();
    setIsEditModalOpen(false);
  };

  const pullForward = () => {

    if (editPullForwardData?.pullforwardType === "For All") {
      if (editPullForwardData?.pullforwardDate) {
        console.log(`in for all`)
        let pull = {
          ...details,
          pullforward: {
            pullforward: editPullForwardData?.pullforward,
            pullforwardNote: editPullForwardData?.pullforwardNote,
            pullforwardDate: new Date(editPullForwardData.pullforwardDate).getTime(),
            pullforwardType: "For All",
            shareBrokers: [],
          },
          status: "PullForward",
        };
        try {
          console.log(`Pull in for all: ${JSON.stringify(pull)}`)
          dispatch(UpdateEnquiry(pull));
          dispatch(fetchCurrentAdminsBranchEnquiries());
          alert(`Pull forward updated successfully`)
          navigate(-1);
        } catch (error) {
          console.log(error.message);
        }
      }
    }

    if (editPullForwardData?.pullforwardType !== "For All") {
      if (editPullForwardData?.pullforwardDate) {
        console.log(`in for broker`)
        let pull = {
          ...details,
          pullforward: {
            pullforward: editPullForwardData.pullforward,
            pullforwardNote: editPullForwardData.pullforwardNote,
            pullforwardDate: new Date(editPullForwardData.pullforwardDate).getTime(),
            shareBrokers: editPullForwardData.shareBrokers,
          },
          status: "Active",
        };
        try {
          console.log(`Pull in for a broker: ${JSON.stringify(pull)}`)
          dispatch(UpdateEnquiry(pull));
          dispatch(fetchCurrentAdminsBranchEnquiries());
          alert(`Pull forward updated successfully`)
          navigate(-1);
        } catch (error) {
          console.log(error.message);
        }
      }
    }

  }

  const getRegionName = () => {
    const region = regions.find((region) => region.regionId === details?.region);
    return region ? region.regionName : "N/A";
  }

  const handleRemoveClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleUpdateClick = () => {
    populateEditPullForwardData();
    setIsEditModalOpen(true);
  };

  const HandleAccept = () => {
    if (Booking.status === "PENDING") {
      setupdatebooking({ ...updatebooking, status: "ACCEPTED" });
      setacceptbuttonclicked(true);
    } else {
      setupdatebooking({ ...updatebooking, status: "PENDING" });
      setOpen(false);
      setacceptbuttonclicked(true);
    }
  };

  const renderEditModal = () => (
    <Modal
      isOpen={isEditModalOpen}
      toggle={() => setIsEditModalOpen(false)}
      centered
      className="modal-modern"
    >
      <ModalHeader toggle={() => setIsEditModalOpen(false)} className={classes.modalHeader}>
        Update Pull Forward
      </ModalHeader>
      <ModalBody>
        <Card className={classes.card}>
          <CardHeader className={classes.cardHeader}>
            <CardTitle tag="h4" className={classes.cardTitle}>
              Pull Forward Details
            </CardTitle>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleUpdateSubmit}>
              <GridContainer spacing={2} className={classes.gridContainer}>
                <GridItem xs={12}>
                  <FormGroup className={classes.formControl}>
                    <Label className={classes.detailLabel}>Pull Forward Type:</Label>
                    <CustomDropDownPicker
                      options={pullforwardTypes}
                      isMulti={false}
                      onChange={(value) => {
                        setEditPullForwardData({ ...editPullForwardData, pullforwardType: value })
                      }}
                      value={editPullForwardData?.pullforwardType === "For All" ? "For All" : "For a Broker"}
                    />
                  </FormGroup>
                </GridItem>
                
                <GridItem xs={12}>
                  <FormGroup className={classes.formControl}>
                    <Label className={classes.detailLabel}>Pull Forward Reason:</Label>
                    <CustomDropDownPicker
                      options={pullforwardReasons}
                      isMulti={false}
                      onChange={(value) => {
                        setEditPullForwardData({ ...editPullForwardData, pullforward: value })
                      }}
                      value={editPullForwardData?.pullforward ? editPullForwardData?.pullforward : null}
                    />
                  </FormGroup>
                </GridItem>
                
                <GridItem xs={12}>
                  <FormGroup className={classes.formControl}>
                    <Label className={classes.detailLabel}>Pull Forward Date:</Label>
                    <Input
                      type="date"
                      fullWidth
                      value={editPullForwardData?.pullforwardDate ? convertUnixDash(editPullForwardData?.pullforwardDate) : null}
                      onChange={(event) => {
                        setEditPullForwardData({ ...editPullForwardData, pullforwardDate: event.target.value })
                      }}
                      style={{
                        fontSize: 15,
                        fontWeight: "400",
                        border: "1px solid",
                        borderColor: "#ced4da",
                        color: "#495057",
                        marginBottom: 5,
                        borderRadius: "6px",
                        padding: "8px 12px"
                      }}
                    />
                  </FormGroup>
                </GridItem>
                
                {editPullForwardData?.pullforwardType !== "For All" && (
                  <GridItem xs={12}>
                    <FormGroup className={classes.formControl}>
                      <Label className={classes.detailLabel}>Pull Forward Brokers:</Label>
                      <CustomDropDownPicker
                        options={brokerList}
                        isMulti={true}
                        value={editPullForwardData?.shareBrokers ? editPullForwardData?.shareBrokers : null}
                        onChange={(value) => {
                          setEditPullForwardData({ ...editPullForwardData, shareBrokers: value })
                        }}
                      />
                    </FormGroup>
                  </GridItem>
                )}
                
                <GridItem xs={12}>
                  <FormGroup className={classes.formControl}>
                    <Label className={classes.detailLabel}>Notes:</Label>
                    <Input
                      type="textarea"
                      name="Notes"
                      value={editPullForwardData?.pullforwardNote ? editPullForwardData?.pullforwardNote : null}
                      onChange={(e) =>
                        setEditPullForwardData({ ...editPullForwardData, pullforwardNote: e.target.value })
                      }
                      style={{
                        border: "1px solid #ced4da",
                        height: "80px",
                        backgroundColor: "white",
                        fontSize: 16,
                        padding: "8px 12px",
                        borderRadius: "6px",
                        color: "#495057"
                      }}
                    />
                  </FormGroup>
                </GridItem>
              </GridContainer>

              <ModalFooter>
                <Button
                  type="submit"
                  className={`${classes.button} ${classes.primaryButton}`}
                >
                  Update
                </Button>
                <Button
                  onClick={() => setIsEditModalOpen(false)}
                  className={`${classes.button} ${classes.secondaryButton}`}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );

  const renderDeleteModal = () => (
    <Modal
      isOpen={isDeleteModalOpen}
      toggle={() => setIsDeleteModalOpen(false)}
      centered
      className="modal-modern"
    >
      <ModalHeader toggle={() => setIsDeleteModalOpen(false)} className={classes.modalHeader}>
        Confirm Remove
      </ModalHeader>
      <ModalBody>
        <p>Are you sure you want to remove the pull forward?</p>
      </ModalBody>
      <ModalFooter>
        <Button 
          onClick={removePullForward}
          className={`${classes.button} ${classes.dangerButton}`}
        >
          Yes, Remove
        </Button>
        <Button 
          onClick={() => setIsDeleteModalOpen(false)}
          className={`${classes.button} ${classes.secondaryButton}`}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );

  const removePullForward = () => {
    let pull = {
      ...details,
      pullforward: {},
      status: "Active"
    };

    try {
      dispatch(UpdateEnquiry(pull));
      alert(`Pull forward removed`);
      dispatch(fetchCurrentAdminsBranchEnquiries());
      navigate(-1);
    } catch (error) {
      console.log(error.message);
      alert(`${error.message}`);
    }
  };

  //////////////////////Render the alert Dialog/////////////////
  const renderAlertDialog = () => {
    return (
      <AlertDialog
        open={commonAlert.open}
        onClose={handleCommonAlertClose}
        title={commonAlert.title}
      >
        {commonAlert.msg}
      </AlertDialog>
    );
  };

  const renderEnquiryData = () => {
    return (
      <>
        <div>
          {isDeleteModalOpen && renderDeleteModal()}
        </div>
        <Container className={classes.pageContainer}>
          <Row>
            <Col md="12" className="mb-3">
              <Button
                className={`${classes.button} ${classes.backButton}`}
                onClick={() => navigate("/enquiries", { state: { item: details } })}
              >
                &larr; Back to Enquiries
              </Button>
            </Col>
          </Row>
          
          <Row className="mb-4">
            <Col md="12">
              <h2 className={classes.sectionTitle}>Enquiry Details</h2>
            </Col>
          </Row>
          
          <Row className="mb-4">
            <Col md="12">
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}>
                  <CardTitle className={classes.cardTitle}>
                    Enquiry Information
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <div className={classes.detailLabel}>Location</div>
                        <div className={classes.detailValue}>{details?.address?.suburb || "N/A"}</div>
                      </FormGroup>
                      
                      {details?.region && (
                        <FormGroup>
                          <div className={classes.detailLabel}>Region</div>
                          <div className={classes.detailValue}>{getRegionName()}</div>
                        </FormGroup>
                      )}
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Type</div>
                        <div className={classes.detailValue}>{details?.type || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Type of Build</div>
                        <div className={classes.detailValue}>{details?.typeOfProperty || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Enquiry Date</div>
                        <div className={classes.detailValue}>
                          {details.enquiryDate
                            ? moment(details.enquiryDate).format("MMMM Do YYYY HH:mm:ss")
                            : "N/A"}
                        </div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Three Phase Power</div>
                        <div className={classes.detailValue}>{details?.isThreePhase || "N/A"}</div>
                      </FormGroup>
                    </Col>
                    
                    <Col md="6">
                      <FormGroup>
                        <div className={classes.detailLabel}>Notes</div>
                        <div className={classes.detailValue}>{details?.notes || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Min Size</div>
                        <div className={classes.detailValue}>{details?.sizeMin || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Max Size</div>
                        <div className={classes.detailValue}>{details?.sizeMax || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Type of Property</div>
                        <div className={classes.detailValue}>{details?.typeOfProperty || "N/A"}</div>
                      </FormGroup>
                      
                      <FormGroup>
                        <div className={classes.detailLabel}>Current (A)</div>
                        <div className={classes.detailValue}>{details?.currentRequirementValue || "N/A"}</div>
                      </FormGroup>
                      
                      {details?.industrialCommercial && (
                        <FormGroup>
                          <div className={classes.detailLabel}>Industrial/Commercial</div>
                          <div className={classes.detailValue}>{details?.industrialCommercial}</div>
                        </FormGroup>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          <Row className="mb-4">
            <Col md="4" className="mb-3">
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}>
                  <CardTitle className={classes.cardTitle}>
                    Owner Details
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <div className={classes.detailLabel}>Business Name</div>
                    <div className={classes.detailValue}>{details?.CompanyName || "N/A"}</div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Client Name</div>
                    <div className={classes.detailValue}>{details?.OwnerName || "N/A"}</div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Contact Number</div>
                    <div className={classes.detailValue}>{details?.PhoneNumber || "N/A"}</div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Email</div>
                    <div className={classes.detailValue}>{details?.Email || "N/A"}</div>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            
            {details?.additionalContacts && (
              <Col md="4" className="mb-3">
                <Card className={classes.card}>
                  <CardHeader className={classes.cardHeader}>
                    <CardTitle className={classes.cardTitle}>
                      Additional Contact Details
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <div className={classes.detailLabel}>Business Name</div>
                      <div className={classes.detailValue}>{details?.addedBusinessName || "N/A"}</div>
                    </FormGroup>
                    
                    <FormGroup>
                      <div className={classes.detailLabel}>Client Name</div>
                      <div className={classes.detailValue}>{details?.addedClientName || "N/A"}</div>
                    </FormGroup>
                    
                    <FormGroup>
                      <div className={classes.detailLabel}>Contact Number</div>
                      <div className={classes.detailValue}>{details?.addedContactNumber || "N/A"}</div>
                    </FormGroup>
                    
                    <FormGroup>
                      <div className={classes.detailLabel}>Email</div>
                      <div className={classes.detailValue}>{details?.AddedEmail || "N/A"}</div>
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            )}
            
            <Col md="4" className="mb-3">
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}>
                  <CardTitle className={classes.cardTitle}>
                    Pull Forward
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <div className={classes.detailLabel}>Pull Forward</div>
                    <div className={classes.detailValue}>{details?.pullforward?.pullforward || "N/A"}</div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Pull Forward Date</div>
                    <div className={classes.detailValue}>
                      {details?.pullforward?.pullforwardDate 
                        ? convertUnix(details?.pullforward?.pullforwardDate) 
                        : "N/A"}
                    </div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Pull Forward Reason</div>
                    <div className={classes.detailValue}>
                      {details?.pullforward?.pullforwardNote || "N/A"}
                    </div>
                  </FormGroup>
                  
                  {details?.pullforward?.pullforwardDate && (
                    <div className="mt-3">
                      <Button
                        className={`${classes.button} ${classes.dangerButton} mr-2`}
                        onClick={handleRemoveClick}
                      >
                        Remove Pull Forward
                      </Button>
                      <Button
                        className={`${classes.button} ${classes.primaryButton}`}
                        onClick={handleUpdateClick}
                      >
                        Update Pull Forward
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
            
            <Col md="4" className="mb-3">
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}>
                  <CardTitle className={classes.cardTitle}>
                    Broker Details
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <div className={classes.detailLabel}>Name</div>
                    <div className={classes.detailValue}>
                      {details?.userdetials?.Name || "N/A"} {details?.userdetials?.lastName || ""}
                    </div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Email</div>
                    <div className={classes.detailValue}>{details?.userdetials?.email || "N/A"}</div>
                  </FormGroup>
                  
                  <FormGroup>
                    <div className={classes.detailLabel}>Contact Number</div>
                    <div className={classes.detailValue}>{details?.userdetials?.mobile || "N/A"}</div>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          {isEditModalOpen && renderEditModal()}
        </Container>
      </>
    );
  };
  
  return <>{renderEnquiryData()}</>;
};

export default StaffEnquiryInformation;